import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/auth-store.js';

/**
 * Wrap routes that require an authenticated user. Renders a small loading
 * indicator while the refresh-based hydration is in flight at app start.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (status === 'idle' || status === 'authenticating') {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-slate-500">
        <span aria-live="polite">Loading…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
